<template>
  <div class="container">
    <div class="logo"></div>
    <router-link
    v-on:click.native="handleJump"
    class="jumpItem addBorder" to="/user/dashBoard">
      <img class="avatarIcon" src="@/assets/icon/Avatar.png" alt="" />
      {{ user.mist.firstname }}
      <img class=" hidden sm:inline-block settingIcon" src="@/assets/icon/setting.png" alt="" />
    </router-link>
    <div class="test">
      <router-link
      v-on:click.native="handleJump" class="jumpItem" to="/user/Profile">Profile </router-link>
      <router-link
      v-on:click.native="handleJump" class="jumpItem" to="/user/vertify">Vertify </router-link>
      <router-link
      v-on:click.native="handleJump"
      class="jumpItem" to="/user/liverate">Live Rate</router-link>
      <!-- <router-link class="jumpItem" to="/user/account">My Account</router-link> -->
      <router-link
      v-on:click.native="handleJump"
      class="jumpItem" to="/user/createorder">Create Order</router-link>
      <!-- <router-link class="jumpItem" to="/user/deposite">Deposit Money</router-link> -->
      <router-link
      v-on:click.native="handleJump"
      class="jumpItem" to="/user/transition">Transaction</router-link>
      <!-- <router-link class="jumpItem" to="/user/bank">Bank Account</router-link>
      <router-link class="jumpItem" to="/user/promote">Promotion</router-link> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('login', ['user']),
    ...mapState(['isMobile'])
  },
  methods: {
    handleJump () {
      if (this.isMobile) {
        this.$emit('leftMenuHide')
      }
    }
  }
}
</script>

<style scoped>
.container {
  flex-shrink: 0;
  width: 300px;
  box-sizing: border-box;
  min-height: 100vh;
  border: 1px solid black;
  background: #163257;
  z-index: 10;
}
.avatarIcon {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}
.settingIcon {
  width: 21px;
  height: 21px;
  right: 25px;
  top: 21px;
  position: absolute;
}
.logo {
  display: block;
  height: 80px;
  width: 100%;
  background: url("../../assets/img/IE-Money-logo-white.svg") no-repeat 29px 26px/183px;
}
.height80 {
  height: 80px;
}
.height60 {
  height: 60px;
}
.jumpItem {
  position: relative;
  display: block;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  padding-left: 24px;
  width: 100%;
  height: 60px;
  text-decoration: none;
  line-height: 48px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
}
.paddingLeft22 {
  padding-left: 22px;
}
.paddingLeft29 {
  padding-left: 29px;
}
.test .router-link-exact-active {
  background: rgba(0, 0, 0, 0.4);
  color: #ffffff;
}
.test .router-link-exact-active::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0px;
  width: 4px;
  height: 100%;
  background: #bc9a41ff;
}
.addBorder {
  border-bottom: 1px solid black;
}
@media only screen and (max-width: 600px) {
.container {
  flex-shrink: 0;
  width: 45vw;
  box-sizing: border-box;
  min-height: 100vh;
  border: 0px solid black;
  background: #163257;
}
.avatarIcon {
  width: 8vw;
  height: 8vw;
  margin-right: 5vw;
}
.settingIcon {
  width: 21px;
  height: 21px;
  right: 12%;
  top: 21px;
  position: absolute;
}
.logo {
  display: block;
  height: 10vh;
  width: auto;
  background: url("../../assets/img/IE-Money-logo-white.svg") no-repeat center center/34vw;
}
.height80 {
  height: 80px;
}
.height60 {
  height: 60px;
}
.jumpItem {
  position: relative;
  display: block;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  padding-left: 24px;
  width: 100%;
  height: 7vh;
  text-decoration: none;
  font-weight: 400;
  justify-content: flex-start;
  font-size: 16px;
  color: #ffffff;
}
.paddingLeft22 {
  padding-left: 0;
}
.paddingLeft29 {
  padding-left: 0;
}
.test{
  margin-top:  1vh;
}
.test .router-link-exact-active {
  background: rgba(0, 0, 0, 0.4);
  color: #ffffff;
}
.test .router-link-exact-active::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0px;
  width: 4px;
  height: 100%;
  background: #bc9a41ff;
}
.addBorder {
  border-bottom: 0px solid black;
}
}
</style>
